/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Stats_Total_UsersInputs */

const en_admin_stats_total_users = /** @type {(inputs: Admin_Stats_Total_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Users`)
};

/**
* | output |
* | --- |
* | "Total Users" |
*
* @param {Admin_Stats_Total_UsersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_stats_total_users = /** @type {((inputs?: Admin_Stats_Total_UsersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Stats_Total_UsersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_stats_total_users(inputs)
});
export { admin_stats_total_users as "admin.stats.total_users" }